module.exports = __webpack_public_path__ + "static/media/number-three.1b4b97e3.svg";